<dx-popup [wrapperAttr]="{ class: 'popupSample' }"
          id="popupComment"
          [width]="615"
          height="auto"
          [showTitle]="true"
          [showCloseButton]="true"
          title="Comment"
          [dragEnabled]="false"
          [hideOnOutsideClick]="false"
          (onHiding)="btnCancel_Click()"
          [(visible)]="__bCommentVisible">
  <div *dxTemplate="let data of 'content'">

    <div class="row message-border">
      <div class="col-lg-12 col-md-12 col-xs-12 message-box">
        <div id="form-limit">
          <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
            <div class="dx-field">
              <div class="dx-field-label">Counterparty: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingCounterpartyName}}</div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Our Entity: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingEntityName}}</div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Limit Type: </div>
              <div class="dx-field-value padding-top-04rem">
                {{__oCounterpartyLimit.LimitTypeName}}
                <span *ngIf="__oCounterpartyLimit.LimitTypeName === 'Volume'" class="buy-sell-span">(Buy-Sell)</span>
              </div>
            </div>
            <div *ngIf="__oCounterpartyLimit.LimitTypeName && __oCounterpartyLimit.LimitTypeName !== 'Volume'" class="dx-field">
              <div class="dx-field-label">Trading Category: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingCategoryName}}</div>
            </div>
            <div *ngIf="__oCounterpartyLimit.LimitTypeName && __oCounterpartyLimit.LimitTypeName === 'Volume'" class="dx-field">
              <div class="dx-field-label">Trading Product: </div>
              <div class="dx-field-value padding-top-04rem">
                {{__oCounterpartyLimit.TradingProductName}}
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Comment:<br>(max 500 characters)</div>
              <div class="dx-field-value padding-top-04rem">
                <dx-text-area id="tbComment" [height]="150" [maxLength]="500"
                              [(value)]="__oCounterpartyLimit.TradingLimitComment">
                </dx-text-area>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="row" style="margin: 0px; ">
      <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
        <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
          <dx-button id="btnPopUpCancel" (onClick)="btnCancel_Click()" text="Cancel"></dx-button>
          <dx-button id="btnOk" (onClick)="btnApply_Click(false)" text="Ok"></dx-button>
        </div>
      </div>
    </div>

  </div>
</dx-popup>
